import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Location, LocationStrategy, PathLocationStrategy, PopStateEvent } from '@angular/common';
import 'rxjs/add/operator/filter';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {Constants} from '../../services/constants/constants.service';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import PerfectScrollbar from 'perfect-scrollbar';

declare var $ :any;

import { NgxUiLoaderService } from 'ngx-ui-loader';

import * as sha512 from 'crypto-js/sha512';

import { AuthenticationService } from '../../services/auth/auth.service';
import { CodigosService } from '../../services/codigos/codigos.service';
import { Session } from '../../services/session/session.service';

@Component({
  selector: 'codigos',
  templateUrl: './codigos.component.html',
  styleUrls: ['./codigos.component.scss'],
})
export class CodigosComponent implements OnInit {
  private _router: Subscription;
  private lastPoppedUrl: string;
  private yScrollStack: number[] = [];
  public loginForm: any;
  public loginResponse: string = "";
  public codigo : any = "";
  public documentoSeleccionado : any = {};

  public API_BASE = Constants.API_BASE;

  public detalles : any = {};

  constructor(
    private ngxService: NgxUiLoaderService,
    public location: Location,
    private router: Router,
    private formBuilder: FormBuilder,
    private authService: AuthenticationService,
    private codigosService: CodigosService,
    private session: Session,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.codigo = this.route.snapshot.paramMap.get("codigo");

    this.cargarDatos();
  }

  cargarDatos(){
    this.codigosService.detallesPorCodigo({codigo: this.codigo}, (data) => {
      if(!data || data.status == 0){
       
        return;
      }

      this.detalles = data;
      console.log(this.detalles);
    });
  }

  verDocumento(documento){
    this.documentoSeleccionado = documento;
    $("#modalDetallesDoc").modal("show");
  }

  abrirDocumento(documento){
    window.open("https://api.idgold.cl/uploadedfiles/misc/trabajadores/" + documento.idTrabajadores + "_" + documento.codigo + "." + documento.extension, "_blank");
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/codigos/codigos.component.ts